// import React, { useEffect, useContext, useState, useRef } from 'react';
// import { useDropzone } from 'react-dropzone';
// import { motion } from 'framer-motion';
// import { toast, ToastContainer } from 'react-toastify'; // Import toast and ToastContainer
// import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for styling
// // import "./ImportSrf.css";
// import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";
// import upload from "../../../../assets/images/rpHomePage/upload.gif";
// import Context from "context/context";
// // import { Box } from '@mui/material';
// import leftarrow from "assets/images/arrow-right.png";
// import { useNavigate } from "react-router-dom";
// import { Box } from '@mui/material';
// // import Context from "context/context";
// import reportAPI from 'apis/panel/reports/reports';
// import Modal from '@mui/material/Modal';
// import Tables from "components/table/table";
// import Typography from '@mui/material/Typography';
// import { IconButton } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import ReusableTable from "components/table/table";
// import Button from '@mui/material/Button';
// import config from "config/config";
// import HandleApiResponse from "utils/handleApiResponse";

// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   // width: "100%",
//   bgcolor: 'background.paper',
//   border: 'none',
//   boxShadow: 24,
//   width: "20vw",
//   // p: 4,
//   borderRadius: "10px",
//   maxHeight: "30vh",
//   overflowY: "scroll",
//   // overflowX: "scroll"
// };



// const YearEnd2024 = () => {
//   const navigate= useNavigate()
//   const { handleResponse, handleError } = HandleApiResponse();

//   const { fileUploadQgendaAPI } = getAllVraShiftAPIS();
//   const [uploadProgress, setUploadProgress] = useState(0); // State to track upload progress
//   const { state, dispatch } = useContext(Context);
//   const [radScheduleData, setRadScheduleData]= useState([]);
//   const [open , setOpen] = useState(false)
//   const [offset, setOffset] = useState(1);
//   const [initial,setInitial]= useState(true)
//   const [count, setCount] = useState(0);
//   const [searchValue, setSearchValue] = useState("");
//   const [missingData , setMissingData]= useState([])
//   const [finalReviewList, setFinalReviewList] = useState([]);
//   const [openPublishModal, setOpenPublishModal] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [isActive, setIsActive] = useState(false);


//   const limit = 10;

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     accept: {
//       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
//       'application/vnd.ms-excel': ['.xls']
//     },
//     onDrop: (acceptedFiles) => {
//       if (acceptedFiles.length > 0) {
//         handleFileUpload(acceptedFiles[0]);
//       } else {
//         toast.error('Only Excel files are allowed.');
//       }
//     },
//   });


//   useEffect(() => {
//     fetchKpiData(searchValue);
//   }, [offset, searchValue]);

//   const fetchKpiData = async (search = "") => {
//     dispatch({ type: "SET_LOADING", payload: true });

//     try {
//         const query = encodeURIComponent(
//           JSON.stringify({
//             offset: (offset - 1) * limit,
//             limit: limit,
//             searchValue: search,
//           })
//         );
        
//         const url = `${config.host}/panel/pms/uploadExcel/completedReviews?query=${query}`;
      
//         const response = await fetch(url, {
//           method: "GET",
//           credentials: "include",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });
      
//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Error response data:", errorData);
//           throw new Error(
//             `HTTP error! status: ${response.status}, ${errorData.message || ""}`
//           );
//         }
      
//         const data = await response.json();
      
//         if (data.status === "Ok" && Array.isArray(data.data.ratingsData)) {
//           const formattedData = data.data.ratingsData.map((rating, index) => [
//             index + 1 + (offset - 1) * limit, 
//             rating.employeeCode,            
//             rating.firstName,                
//             rating.role,                     
//             rating.managerName,              
//             rating.managerRating,            
//           ]);
          
//           setFinalReviewList(formattedData);
//           setCount(data.data.count);
          
      
//           dispatch({ type: "SET_LOADING", payload: false });
//         } else {
//           console.error("Unexpected data format:", data);
//           setFinalReviewList([]); 
//         }
//       } catch (error) {
//         console.error("Error fetching KPI data:", error);
//         dispatch({ type: "SET_LOADING", payload: false });
//       }
//   };





//   const handlePublish = () => {
//     setOpenPublishModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setIsActive(false);
//   };
//   const handleClosepublishModal = () => {
//     setOpenPublishModal(false);
//   };

//   const handleConfirmPublish = async () => {
//     dispatch({ type: "SET_LOADING", payload: true });

//     try {
//       const response = await fetch(`${config.host}/panel/pms/hr/publishRatings`, {
//         method: "POST",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error("Error publishing ratings:", errorData);
//         toast.error("Failed to publish ratings");
//         dispatch({ type: "SET_LOADING", payload: false });

//         return;
//       }

//       const result = await response.json();
//       if (result.status === "Ok" && result.data.updated > 0) {
//         toast.success("Ratings published successfully");
//         dispatch({ type: "SET_LOADING", payload: false });

//       } else {
//         toast.error("No ratings were updated");
//         dispatch({ type: "SET_LOADING", payload: false });

//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//       toast.error("An error occurred while publishing ratings");
//       dispatch({ type: "SET_LOADING", payload: false });

//     } finally {
//       setOpenPublishModal(false); // Close modal after API call
//       dispatch({ type: "SET_LOADING", payload: false });

//     }
//   };

//   const handleFileUpload = async (file) => {
//     const maxSize = 1024 * 1024 * 5; // 5MB
//     if (file.size > maxSize) {
//       // Show error message if file size exceeds the limit
//       toast.error("File size exceeds the limit (5MB)", {
//         toastId: "file-upload-maximum",
//       });
//       return;
//     }

    
//     try {
//       dispatch({ type: "SET_LOADING", payload: true });

//       const response= await fileUploadRatingAPI(file)

//       dispatch({ type: "SET_LOADING", payload: false });

//       if (response?.status==200) {
//         toast.success(response?.detail);
//         setMissingData(response?.missing_rad_names)
//         // console.log(missingData,"missingData")
//         setUploadProgress(0); 
//         setOpen(true)
//         return response.detail;
//       }else{
//         toast.error(response?.detail);
//         setUploadProgress(0); 
//         return;
//       }

      
      
//     } catch (err) {
//       dispatch({ type: "SET_LOADING", payload: false });
      
//       console.error('Error uploading file:', err);
//       toast.error('Error uploading file.');
//     }
//   };

//   async function fileUploadRatingAPI(file) {
//     try {
//       const formData = new FormData();
//       formData.append("file", file);
      
//       const obj = {
//         method: "POST",
//         credentials: "include",
//         body: formData,
//       };
  
//       let res = await fetch(`${config.host}/panel/pms/uploadExcel/yearEndRating`, obj);
      
//       // Check if the response is OK before processing
//       if (!res.ok) {
//         throw new Error(`Error: ${res.statusText}`);
//       }
//       fetchKpiData();
  
//       return handleResponse(res); // Make sure handleResponse is processing the response correctly
//     } catch (err) {
//       handleError(err); // Handle the error properly
//     }
//   }
  

//   const handleClose = () => {
//     setOpen(false);
//   }
  
//   const handleNavigation=()=>{
//     navigate("/panel/rpHomePage")
//   }


//   return (
//     <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
//     <div style={{ display: "flex", alignItems: "center" }}>
//       <Box sx={{ pt: 2, pb: 2, pl: 1 }} className="VraShiftsTitle">
//         Import Rating Report
//       </Box>
//     </div>
//     <div
//       className="containerforupload"
//       style={{
//         width: "300px", // Reduced width
//         margin: "0 auto", // Centered container
//         textAlign: "center", // Align content to center
//       }}
//     >
//       <motion.div
//         className="upload-area"
//         {...getRootProps()}
//         whileHover={{ scale: 1.05 }}
//         whileTap={{ scale: 0.95 }}
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 0.5 }}
//         style={{
//           border: "2px dashed lightgrey", // Border for better visibility
//           borderRadius: "10px", // Rounded corners
//           padding: "20px", // Reduced padding
//           height: "150px", // Smaller height
//         }}
//       >
//         <input {...getInputProps()} />
//         <div className="instructions">
//           {isDragActive ? (
//             <img style={{ width: "60px", height: "60px" }} src={upload} alt="Upload indicator" /> // Smaller icon
//           ) : (
//             <>
//               <img style={{ width: "60px", height: "60px" }} src={upload} alt="Upload indicator" />
//               <p style={{ color: "lightgrey", fontSize: "14px" }}>
//                 Drag and drop your Excel files here
//               </p>
//             </>
//           )}
//         </div>
//       </motion.div>
  
//       {uploadProgress > 0 && (
//         <div className="progress-container">
//           <div
//             className="progress-bar"
//             style={{ width: `${uploadProgress}%`, height: "5px" }} // Smaller progress bar
//           >
//             {uploadProgress}%
//           </div>
//         </div>
//       )}
//       <ToastContainer />
//     </div>
//     <Box sx={{ width: '100%', typography: 'body1' }}>
         
         

//             <div style={{ display: 'flex', justifyContent: 'center' }}>
//               <div style={{ width: '100%', overflowX: 'auto' }}>

//                 <ReusableTable
//                   title={<div className="leavemanageHeading">Year End Rating</div>
//                   }
//                 //   create={<Button className="AddKrabutton" onClick={handlePublish}>
//                 //     Publish
//                 //   </Button>}
//                   searchBar
//                   data={Array.isArray(finalReviewList) ? finalReviewList : []}
//                   count={count}
//                   offset={offset}
//                   setOffset={setOffset}
//                   limit={limit}
//                   setSearchValue={setSearchValue}
//                   heading={["S.No", "Employee ID", "Employee Name", "Role", "Reporting","Final Rating"]}
//                   placeholder="Search Employee..."
//                 />
//               </div>
//             </div>
          
         
//       </Box>

//       <Modal
//         open={openPublishModal}
//         onClose={handleCloseModal}
//         aria-labelledby="publish-confirmation-title"
//         aria-describedby="publish-confirmation-description"
//       >
//         <div
//           style={{
//             width: "400px",
//             margin: "auto",
//             marginTop: "15%",
//             backgroundColor: "white",
//             padding: "20px",
//             borderRadius: "8px",
//             boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//             textAlign: "center",
//           }}
//         >
//           <Typography id="publish-confirmation-title" variant="h6">
//             Confirm Publish
//           </Typography>
//           <Typography
//             id="publish-confirmation-description"
//             style={{ marginTop: "10px", color: "#666" }}
//           >
//             Once published, ratings cannot be changed. Are you sure you want to
//             proceed?
//           </Typography>
//           <div
//             style={{
//               marginTop: "20px",
//               display: "flex",
//               justifyContent: "space-between",
//             }}
//           >
//             <Button variant="outlined" onClick={handleClosepublishModal}>
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleConfirmPublish}
//             >
//               Confirm
//             </Button>
//           </div>
//         </div>
//       </Modal>
  
//     {missingData.length > 0 ? (
//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box sx={style}>
//           <Tables
//             title={
//               <Box sx={{ pt: 2, pb: 2, pl: 1 }} className="VraShiftsTitle">
//                 Missing RAD Names
//               </Box>
//             }
//             setSearchValue={setSearchValue}
//             create={
//               <IconButton onClick={handleClose}>
//                 <CloseIcon
//                   style={{ border: "2px solid grey", borderRadius: "5px" }}
//                 />
//               </IconButton>
//             }
//             heading={["S.No", "Missing RAD Names"]}
//             data={missingData?.map((e, index) => [
//               (offset - 1) * 20 + index + 1, // S.No
//               e,
//             ])}
//             offset={offset}
//             setOffset={setOffset}
//             count={count}
//             placeholder="Search by Name"
//             limit={20}
//           />
//         </Box>
//       </Modal>
      
//     ) : (
//       ""
//     )}
//   </div>
//     );
// };

// export default YearEnd2024;
